import data from "../../../../../src/Box.docs.json";
import * as React from 'react';
export default {
  data,
  React
};